import React from 'react';
import LearningCard from '../components/LearningCard';

const ScratchAndWinHosts = () => (
  <LearningCard
    testid="scratch-and-win-hosts"
    logoSrc="/logo-scratch-win.png"
    logoAlt="Scratch & Win"
    logoRound={false}
    title="Scratch & Win Activatie"
    subtitle="Host Briefing"
    support={[
      'Tijdens het Pinksterweekend, van 23 tot en met 25 mei, loopt de Scratch & Win activatie in de Village.',
      'Gasten die hun Membership code scannen bij meerdere boutiques, maken kans op een Scratch & Win lot. Vanaf 4 boutiques ontvangen ze hun eerste lot. Bij elke extra boutique krijgen ze een bijkomend lot, met een maximum van 5 Scratch & Win loten per member.',
      'De activatie vindt plaats aan de oude desk op het Michael Kors plein, uitgebreid met een dakje. Er zijn 2 hosts per dag aanwezig. Bij slecht weer verhuist de activatie naar de desk in Client Services.',
      'In deze microlearning leer je hoe je gasten ontvangt, hoe je hun notificatie en Coniq scan controleert, hoe je het Scratch & Win lot correct verwerkt en hoe je winnaars begeleidt naar hun prijs.',
    ]}
    buttons={[
      {
        label: 'Open de microlearning',
        href: 'https://app.qoldo.com/p/5fd35e2e-8bb6-42b3-84cf-6b5d8ad52a54?t=2689605a-9a6e-4df0-9c8f-fe68a78bef15',
        testid: 'btn-open-microlearning',
      },
    ]}
  />
);

export default ScratchAndWinHosts;
